import { Action } from "~/modules/actions/Action";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { CbmImpl, TaskParticipant } from "~/modules/cbm";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getReservationsByTask, isEmailTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";




















export class RemoveEmailParticipant implements Action<Promise<TaskParticipant>> {
    #taskSid: string;

    #participantSid: string;

    constructor(taskSid: string, participantSid: string) {
        this.#taskSid = taskSid;
        this.#participantSid = participantSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        const reservation = getReservationsByTask(worker, this.#taskSid)[0];
        if (!reservation) {
            const errorMsg = `RemoveEmailParticipant: Reservation for task ${this.#taskSid} not found`;

            sendTrackingEvent(EVENTS.RemoveEmailParticipantCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                participantSid: this.#participantSid
            });

            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const task = reservation.task;

        if (!isEmailTask(task)) {
            const errorMsg = `RemoveEmailParticipant: Task ${this.#taskSid} is not an email task`;
            sendTrackingEvent(EVENTS.RemoveEmailParticipantCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                participantSid: this.#participantSid
            });

            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
        try {
            const participant = await cbm.removeEmailParticipant(task, this.#participantSid);
            sendTrackingEvent(EVENTS.RemoveEmailParticipantCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                participantSid: this.#participantSid
            });
            return participant;
        } catch (error) {
            const errorMsg = `RemoveEmailParticipant: Failed to to remove email participant: ${error.message}`;
            logger.error("Failed to remove email participant", error);
            sendTrackingEvent(EVENTS.RemoveEmailParticipantCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                participantSid: this.#participantSid
            });
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
